<template>
    <div class="study-column">
        <h2 class="blue"><span></span>{{title}}</h2>
        <slot></slot>        
    </div>
</template>

<script>

export default{
    name: 'Column',
    data(){
        return{
            
        }
    },
    props:{
        title: String
    }
}
</script>

<style lang="less" scoped>
    .study-column{
        padding: 0 0.3rem;
        h2{
            font-size: 0.45rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.2rem;
            span{
                display: inline-block;
                height: 0.6rem;
                width: 0.15rem;
                background: #3793f4;
                vertical-align: middle;
                margin-right: 0.25rem;
                border-radius: 0.2rem;
            }
        }
        .blue{
            color: #1960ab;
        }
    }          
</style>   